const colorAxis = {
  dataClasses: [
    {
      to: 0,
      color: '#6D6F70',
      name: 'No Data',
    },
    {
      from: 0.0000000001,
      to: 1,
      color: '#218371',
      plotBorderColor: '#C0C0C0',
      borderWidth: 1,
      name: 'Very Low',
    },
    {
      from: 1.0000000001,
      to: 2,
      color: '#6CB2A2',
      plotBorderColor: '#C0C0C0',
      borderWidth: 1,
      name: 'Relatively Low',
    },
    {
      from: 2.0000000001,
      to: 3,
      color: '#FFFFF0',
      plotBorderColor: '#C0C0C0',
      borderWidth: 1,
      name: 'Relatively Moderate',
    },
    {
      from: 3.0000000001,
      to: 4,
      color: '#FB8D7B',
      plotBorderColor: '#C0C0C0',
      borderWidth: 1,
      name: 'Relatively High',
    },
    {
      from: 4.0000000001,
      color: '#C40000',
      plotBorderColor: '#C0C0C0',
      borderWidth: 1,
      name: 'Very High',
    },
  ],
}
export default colorAxis
